document.addEventListener('DOMContentLoaded', function() {
  const elementsToAnimate = document.querySelectorAll(
    '.shopify-section, .product-card, .collection-card, .content-block, img, h1, h2, h3, p'
  );
  
  elementsToAnimate.forEach(element => {
    element.classList.add('fade-up-element');
  });
  
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
      }
    });
  }, {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  });
  
  elementsToAnimate.forEach(element => {
    observer.observe(element);
  });
});
